import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CheckoutService } from '@checkout-v2/feature';
import { CustomOrder } from '@order/const';
import { OnlineOrderService } from '@order/feature';
import { SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { UrlModule } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, startWith, switchMap } from 'rxjs/operators';

@Component({
  selector: 'sd-order-confirmation-info-invoice-button',
  templateUrl: './order-confirmation-info-invoice-button.component.html',
  styleUrls: ['./order-confirmation-info-invoice-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, UrlModule, SdvorButtonComponent],
})
export class OrderConfirmationInfoInvoiceButtonComponent implements OnInit {
  order$: Observable<CustomOrder>;
  loading$: Observable<boolean>;

  constructor(
    private checkoutService: CheckoutService,
    private onlineOrderService: OnlineOrderService,
  ) {}

  ngOnInit(): void {
    this.order$ = this.checkoutService
      .getOrderDetails()
      .pipe(filter<CustomOrder>((order) => Object.keys(order || {}).length > 0));

    this.loading$ = this.order$.pipe(
      switchMap((order) => this.onlineOrderService.getOrderInvoicePaymentLoading(order.guid)),
      startWith(false),
    );
  }

  onClickButtonBill(order: CustomOrder): void {
    this.onlineOrderService.downloadOrderInvoicePayment(order.guid, order.code);
  }
}
